import axios from "axios";
import {
  CREATE_DELIVERY_PINCODE,
  DELETE_DELIVERY_PINCODE,
  EDIT_DELIVERY_PINCODE,
  ENABLE_DISABLE_DELIVERY_PINCODE,
  GET_DELIVERY_PINCODE,
  GET_DELIVERY_PINCODE_DETAILS,
} from "../../constants/ApiConstant";
import { ToastMessage } from "../../utils/Helper";

/**
 * get delivery pincode list data
 * @param {pagination params} paramsObj
 * @returns data response
 */

export const get_Delivery_Pincode = (paramsObj) => {
  const jwt_token = localStorage.getItem("authToken");
  return axios
    .get(`${process.env.REACT_APP_API_URL}${GET_DELIVERY_PINCODE}`, {
      headers: { Authorization: jwt_token },
      params: paramsObj,
    })
    .then((res) => res.data);
};

/**
 * add delivery pincode api call
 * @param {form data} formData
 * @returns
 */

export const Create_Delivery_Pincode = (formData) => {
  const jwt_token = localStorage.getItem("authToken");
  return axios
    .post(
      `${process.env.REACT_APP_API_URL}${CREATE_DELIVERY_PINCODE}`,
      formData,
      {
        headers: { Authorization: jwt_token },
      }
    )
    .then((message) => {
      return message;
    })
    .catch((error) => {
      const { status, message } = error?.response?.data || error;
      ToastMessage(status, message);
    });
};

/**
 *enable - disable delivery pincode api call
 * @param {form data as isActive & deliveryPincodeId} formData
 * @param {list api call function} refetch
 * @returns true & false
 */

export const Enable_Disable_Delivery_Pincode = (formData, refetch) => {
  const jwt_token = localStorage.getItem("authToken");
  return axios
    .put(
      `${process.env.REACT_APP_API_URL}${ENABLE_DISABLE_DELIVERY_PINCODE}`,
      formData,
      {
        headers: { Authorization: jwt_token },
        params: { deliveryPincodeId: formData.deliveryPincodeId },
      }
    )
    .then((message) => {
      refetch();
      ToastMessage(message.status, message.data.message);
    })
    .catch((error) => {
      if (error.response) {
        const { status, message } = error?.response?.data || error;
        ToastMessage(status, message);
      }
    });
};

/**
 * get details delivery pincode
 * @param {*} deliveryPincodeId
 * @param {form data func} setFormData
 * @param {modal func} setdialogs
 * @returns
 */
export const Get_Details_Delivery_Pincode = (
  deliveryPincodeId,
  setFormData,
  setdialogs
) => {
  const jwt_token = localStorage.getItem("authToken");
  return axios
    .get(`${process.env.REACT_APP_API_URL}${GET_DELIVERY_PINCODE_DETAILS}`, {
      headers: { Authorization: jwt_token },
      params: { deliveryPincodeId },
    })
    .then((res) => {
      let data = res.data.payload.data;
      setFormData({
        pincode: data?.pincode ? data?.pincode : "",
        city: data?.city ? data?.city : "",
        state: data?.state ? data?.state : "",
        county: data?.county ? data?.county : "",
        isAll: data?.isAll ? data?.isAll : false,
      });
      setdialogs(true);
    });
};

/**
 * update delivery pincode api call
 * @param {form data} formData
 * @param {*} deliveryPincodeId
 * @returns
 */

export const Put_Update_Delivery_Pincode = (formData, deliveryPincodeId) => {
  const jwt_token = localStorage.getItem("authToken");
  return axios
    .put(`${process.env.REACT_APP_API_URL}${EDIT_DELIVERY_PINCODE}`, formData, {
      headers: { Authorization: jwt_token },
      params: { deliveryPincodeId },
    })
    .then((message) => {
      return message;
    })
    .catch((error) => {
      const { status, message } = error?.response?.data || error;
      ToastMessage(status, message);
    });
};

/**
 * delete delivery pincode api call
 * @param {form data} formData
 * @param {*} deliveryPincodeId
 * @param {list api call } refetch
 * @returns
 */

export const Delete_Delivery_Pincode = (deliveryPincodeId, refetch) => {
  const jwt_token = localStorage.getItem("authToken");
  return axios
    .delete(`${process.env.REACT_APP_API_URL}${DELETE_DELIVERY_PINCODE}`, {
      headers: { Authorization: jwt_token },
      params: { deliveryPincodeId },
    })
    .then((message) => {
      refetch();
      ToastMessage(message.status, message.data.message);
    })
    .catch((error) => {
      const { status, message } = error?.response?.data || error;
      ToastMessage(status, message);
    });
};
